module.exports = __webpack_public_path__ + "img/bulle-etudiant.706cce8.png";